export default "__VITE_ASSET__a66c05a9__"